import { Reducer } from 'redux';
import {
  IUserStore,
  VerifyBankAccountState,
  VerifyDocumentRequestState,
  VerifyIFCS_State,
} from './type';
import { TypesUser } from 'redux/actions/user/type';
import { getStoragePhoneLogin, getStorageRefreshToken, getStorageUserId } from 'utils';
import { TypesLayout } from 'core/redux/actions/lyaout/type';

const userState: IUserStore = {
  userInfo: {
    id: getStorageUserId(),
    registration_step: 1,
    isLoading: false,
    isLoaded: false,
    isFailed: false,
  },

  userPayments: {
    paymentHistory: [],

    isLoading: false,
    isLoaded: false,
    isFailed: false,
  },

  statusOfLoan: null,
  isSendAadhaarOtpLoading: false,

  verifyDocumentInfo: null,

  verifyBankAccount: null,

  verifyIFCS: {
    isLoading: false,
  },

  experian: null,
  kyc_details: null,

  isSendOTPExperianLoader: false,

  phoneLogin: getStoragePhoneLogin(),
  refreshToken: getStorageRefreshToken(),

  aadhaarCardInfo: null,

  isSelfieUploaded: false,
  isPanCardUploaded: false,
  isConsentGivenSent: false,
  isShowLoader: false,
  isShowActionLoader: false,
  isForensicsRequestProcessed: false,
  isForensicsRequestProcessing: false,
  forensics_details: null,
  livenessResult: null,
  appSetting: null,
  retryAfter: undefined,
  preferable_languages: null,

  aadhaarVerificationInfo: {
    token: null,
    expiredTime: null,
    sessionClientId: null,
  },
};

export const user: Reducer<IUserStore> = (state = userState, action) => {
  switch (action.type) {
    case TypesUser.CREATE_USER_SUCCESS:
      return {
        ...state,
        userInfo: {
          ...action.data,
        },
      };
    case TypesUser.GET_USER_INFO_REQUEST:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          isLoading: true,
        },
      };
    case TypesUser.GET_USER_INFO_SUCCESS:
      return {
        ...state,
        userInfo: {
          ...action.data,
          isLoading: false,
          isLoaded: true,
        },
      };
    case TypesUser.GET_USER_INFO_ERROR:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          isLoading: false,
          isFailed: true,
        },
      };
    case TypesUser.GET_PREFERABLE_LANGUAGES_REQUEST:
      return {
        ...state,
        preferable_languages: null,
      };
    case TypesUser.GET_PREFERABLE_LANGUAGES_SUCCESS:
      return {
        ...state,
        preferable_languages: action.data,
      };
    case TypesUser.GET_PREFERABLE_LANGUAGES_ERROR:
      return {
        ...state,
      };

    case TypesUser.PATCH_USER_SUCCESS:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          ...action.data,
        },
      };

    case TypesUser.SEND_OTP_USER_REQUEST:
      return {
        ...state,
        retryAfter: null,
      };

    case TypesUser.SEND_OTP_USER_SUCCESS:
      return {
        ...state,
        phoneLogin: action.data,
      };

    case TypesUser.LOGIN_OTP_USER_REQUEST:
      return {
        ...state,
      };

    case TypesUser.LOGIN_OTP_USER_SUCCESS:
      return {
        ...state,
        isShowLoader: false,
      };

    case TypesUser.LOGIN_OTP_USER_ERROR:
      return {
        ...state,
      };

    case TypesUser.CLEAR_LOGIN_SESSION:
      return {
        ...state,
        phoneLogin: null,
      };
    case TypesUser.CLEAR_USER:
      return {
        ...state,
        userInfo: {
          id: 0,
          registration_step: 1,
          isLoading: false,
          isLoaded: false,
          isFailed: false,
        },
      };
    case TypesUser.GET_USER_PAYMENTS_REQUEST:
      return {
        ...state,
        userPayments: {
          ...state.userPayments,
          isLoading: true,
        },
      };
    case TypesUser.GET_USER_PAYMENTS_SUCCESS:
      return {
        ...state,
        userPayments: {
          ...state.userPayments,
          paymentHistory: action.data,
          isLoading: false,
          isLoaded: true,
        },
      };
    case TypesUser.GET_USER_PAYMENTS_ERROR:
      return {
        ...state,
        userPayments: {
          ...state.userPayments,
          isLoading: false,
          isFailed: true,
        },
      };
    case TypesUser.LOGOUT:
    case TypesLayout.LOGOUT: {
      return {
        ...userState,
        userInfo: {
          ...userState.userInfo,
          id: null,
        },
      };
    }

    case TypesUser.POST_VERIFY_DOCUMENT_REQUEST:
    case TypesUser.GET_VERIFY_DOCUMENT_REQUEST:
      return {
        ...state,
        verifyDocumentInfo: { request_state: VerifyDocumentRequestState.Pending },
      };

    case TypesUser.POST_VERIFY_DOCUMENT_SUCCESS:
    case TypesUser.GET_VERIFY_DOCUMENT_SUCCESS:
      return { ...state, verifyDocumentInfo: action.data };

    case TypesUser.POST_VERIFY_DOCUMENT_ERROR:
    case TypesUser.GET_VERIFY_DOCUMENT_ERROR:
      return { ...state, verifyDocumentInfo: action.data };

    case TypesUser.GET_AADHAAR_CARD_DETAILS_REQUEST:
      return {
        ...state,
        aadhaarCardInfo: { isLoading: true },
      };

    case TypesUser.GET_AADHAAR_CARD_DETAILS_SUCCESS:
      return {
        ...state,
        aadhaarCardInfo: { ...action.data, isLoading: true },
        isSendAadhaarOtpLoading: false,
      };

    case TypesUser.GET_AADHAAR_CARD_DETAILS_ERROR:
      return {
        ...state,
        aadhaarCardInfo: { ...action.data, isLoading: false },
      };

    case TypesUser.POST_VERIFY_BANK_ACCOUNT_REQUEST:
      return {
        ...state,
        verifyBankAccount: { ...state.verifyBankAccount, ...action.data, isLoading: true },
      };

    case TypesUser.POST_VERIFY_BANK_ACCOUNT_SUCCESS:
      return {
        ...state,
        verifyBankAccount: { ...state.verifyBankAccount, ...action.data, isLoading: true },
      };

    case TypesUser.POST_VERIFY_BANK_ACCOUNT_ERROR:
      return {
        ...state,
        userInfo: { ...state.userInfo, ...action.data },
        verifyBankAccount: { ...state.verifyBankAccount, ...action.data, isLoading: false },
      };

    case TypesUser.GET_VERIFY_BANK_ACCOUNT_REQUEST:
      return {
        ...state,
        verifyBankAccount: { state: VerifyBankAccountState.PENDING, isLoading: true },
      };

    case TypesUser.GET_VERIFY_BANK_ACCOUNT_SUCCESS:
      return {
        ...state,
        userInfo: { ...state.userInfo, ...action.data },
        verifyBankAccount: { state: VerifyBankAccountState.SUCCESS, isLoading: false },
      };

    case TypesUser.GET_VERIFY_BANK_ACCOUNT_ERROR:
      return {
        ...state,
        verifyBankAccount: { state: VerifyBankAccountState.ERROR, isLoading: false },
      };

    case TypesUser.CLEAR_VERIFY_IFCS:
      return {
        ...state,
        verifyIFCS: null,
      };

    case TypesUser.GET_IFCS_REQUEST:
      return {
        ...state,
        verifyIFCS: { state: VerifyIFCS_State.PENDING, isLoading: true },
      };

    case TypesUser.GET_IFCS_SUCCESS:
      return {
        ...state,
        verifyIFCS: { state: VerifyIFCS_State.SUCCESS, isLoading: false, data: { ...action.data } },
      };

    case TypesUser.GET_IFCS_ERROR:
      return {
        ...state,
        verifyIFCS: { state: VerifyIFCS_State.ERROR, isLoading: false, ...action.error },
      };

    case TypesUser.GET_EXPERIAN_INFO_REQUEST:
      return { ...state };

    case TypesUser.GET_EXPERIAN_INFO_SUCCESS:
      return { ...state, experian: { ...action.data, isLoading: true } };

    case TypesUser.GET_EXPERIAN_INFO_ERROR:
      return { ...state, experian: { isLoading: true } };

    case TypesUser.GET_KYC_DETAILS_SUCCESS:
      return {
        ...state,
        kyc_details: { ...state.kyc_details, ...action.data },
      };

    case TypesUser.POST_EXPERIAN_INFO_SUCCESS:
      return { ...state, experian: { ...state.experian, ...action.data } };

    case TypesUser.POST_EXPERIAN_INFO_ERROR:
      return { ...state, experian: { isLoading: true } };

    case TypesUser.POST_BANK_STATEMENT_ANALYSIS_SUCCESS:
      return {
        ...state,
        bank_statement_analysis: { ...state.kyc_details?.bank_statement_analysis, ...action.data },
      };

    case TypesUser.POST_BANK_STATEMENT_ANALYSIS_ERROR:
      return { ...state, bank_statement_analysis: { isLoading: true } };

    case TypesUser.SEND_CONFIRM_CODE_EXPERIAN_REQUEST:
      return { ...state, isSendOTPExperianLoader: true };

    case TypesUser.SEND_CONFIRM_CODE_EXPERIAN_SUCCESS:
      return {
        ...state,
        experian: { ...state.experian, ...action.data },
        isSendOTPExperianLoader: false,
      };

    case TypesUser.SEND_CONFIRM_CODE_EXPERIAN_ERROR:
      return { ...state, isSendOTPExperianLoader: false };

    case TypesUser.POST_UPLOAD_PANCARD_FRONT_REQUEST:
      return { ...state, isShowLoader: true };

    case TypesUser.SEND_AADHAR_OTP_USER_REQUEST:
      return { ...state, isSendAadhaarOtpLoading: true };

    case TypesUser.POST_UPLOAD_PANCARD_FRONT_SUCCESS:
      return { ...state, isPanCardUploaded: true, isShowLoader: false };

    case TypesUser.POST_UPLOAD_PANCARD_FRONT_ERROR:
      return { ...state, isPanCardUploaded: false, isShowLoader: false };

    case TypesUser.POST_UPLOAD_SELFIE_AND_PANCARD_FRONT_REQUEST:
      return { ...state, isShowLoader: true };

    case TypesUser.POST_UPLOAD_SELFIE_AND_PANCARD_FRONT_SUCCESS:
      return { ...state, isSelfieUploaded: true, isShowLoader: false };

    case TypesUser.POST_UPLOAD_SELFIE_AND_PANCARD_FRONT_ERROR:
      return { ...state, isSelfieUploaded: false, isShowLoader: false };

    case TypesUser.STATUS_OF_LOAN_SUCCESS:
      return { ...state, statusOfLoan: true };

    case TypesUser.POST_CONSENT_GIVEN_REQUEST:
      return { ...state, isConsentGivenSent: false };

    case TypesUser.POST_CONSENT_GIVEN_SUCCESS:
      return { ...state, isConsentGivenSent: true };

    case TypesUser.POST_CONSENT_GIVEN_ERROR:
      return { ...state, isConsentGivenSent: false };

    case TypesUser.POST_OZ_FORENSICS_REQUEST:
      return { ...state, forensics_details: { ...action.data }, isShowActionLoader: true };

    case TypesUser.POST_OZ_FORENSICS_SUCCESS:
      return { ...state, forensics_details: { ...action.data }, isShowActionLoader: false };

    case TypesUser.POST_OZ_FORENSICS_ERROR:
      return { ...state, livenessResult: { ...action.data }, isShowActionLoader: false };

    case TypesUser.POST_OZ_LIVENESS_RESULT_REQUEST:
      return {
        ...state,
        livenessResult: { ...state.livenessResult, ...action.data, isLoading: true },
        isForensicsRequestProcessed: false,
        isForensicsRequestProcessing: true,
        isShowActionLoader: true,
      };

    case TypesUser.POST_OZ_LIVENESS_RESULT_SUCCESS:
      return {
        ...state,
        livenessResult: { ...state.livenessResult, ...action.data, isLoading: false },
        isForensicsRequestProcessed: true,
        isForensicsRequestProcessing: false,
        isShowActionLoader: true,
      };

    case TypesUser.POST_OZ_LIVENESS_RESULT_ERROR:
      return {
        ...state,
        livenessResult: { ...state.livenessResult, ...action.data, isLoading: false },
        isForensicsRequestProcessed: false,
        isForensicsRequestProcessing: false,
        isShowActionLoader: false,
      };

    case TypesUser.GET_APP_SETTINGS_REQUEST:
      return {
        ...state,
        appSetting: {
          ...action.data,
          isLoading: true,
        },
      };
    case TypesUser.GET_APP_SETTINGS_SUCCESS:
      return {
        ...state,
        appSetting: {
          ...action.data,
          isLoading: false,
          isLoaded: true,
        },
      };
    case TypesUser.GET_APP_SETTINGS_ERROR:
      return {
        ...state,
        appSetting: {
          ...action.data,
          isLoading: false,
          isFailed: true,
        },
      };

    case TypesUser.SAVE_RETRY_AFTER:
      return {
        ...state,
        retryAfter: action.data,
      };

    case TypesUser.REMOVE_RETRY_AFTER:
      return {
        ...state,
        retryAfter: undefined,
      };

    case TypesUser.SET_AADHAAR_VERIFICATION_INFO:
      return {
        ...state,
        aadhaarVerificationInfo: {
          token: action.data?.token ?? null,
          expiredTime: action.data?.expired_at ?? null,
          sessionClientId: action?.data?.client_id ?? null,
          status: action?.data?.status ?? null,
        },
      };

    default:
      return state;
  }
};
